import { useMedia } from "react-use";

export const DEFAULT_SCREEN_SIZES = {
  MOBILE: 375,
  TABLET: 768,
  DESKTOP: 1280,
};

export const LAYOUT_CONSTANTS = {
  DESKTOP_CONTENT_WIDTH: "1275px",
  MIN_CONTENT_WIDTH: "320px",
  RESPONSIVE_BREAKPOINTS: {
    MOBILE: "768px",
    TABLET: "1024px",
    DESKTOP: "1200px",
    LARGE_DESKTOP: "1400px",
  },
};

const size = {
  mobile: DEFAULT_SCREEN_SIZES.MOBILE,
  tablet: DEFAULT_SCREEN_SIZES.TABLET,
  desktop: DEFAULT_SCREEN_SIZES.DESKTOP,
};

export const device = {
  mobile: `(max-width: ${size.tablet - 1}px)`,
  /** Tablet and up (single column layouts break to side-by-side here). */
  minTablet: `(min-width: ${size.tablet}px)`,
  tablet: `(min-width: ${size.tablet}px) and (max-width: ${
    size.desktop - 1
  }px)`,
  desktop: `(min-width: ${size.desktop}px)`,
};

export const useBreakpoints = () => {
  const isMobile = useMedia(device.mobile);
  const isTablet = useMedia(device.tablet);
  const isDesktop = useMedia(device.desktop);

  return {
    isMobile,
    isTablet,
    isDesktop,
    isTabletOrAbove: isTablet || isDesktop,
  };
};
